module.exports = __webpack_public_path__ + "img/23.7ee26a0c.png";